import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';

// -- tools
import CurrencyUtils from 'PMT/utils/CurrencyUtils';

// -- views
import Payout from 'PMT/entities/Payout';

export default class PayoutsTableViewRow extends Component {

  static propTypes = {
    payout: PropTypes.objectOf(Payout).isRequired,
    currencyCode: PropTypes.string,
  };

  render(): Object {
    const payout: Payout = this.props.payout;
    const currencyCode: string = this.props.currencyCode;

    console.log("payout", payout)

    return (
      <tr>
        <td>{payout.id}</td>

        <td>{payout.reference}</td>

        <td>{payout.getFormattedDate()}</td>

        <td
          className="text-center"
        >
          {CurrencyUtils.formatPriceWithCurrency(payout.grossAmount,
              currencyCode)}
        </td>

        <td
          className="text-center"
        >
          {CurrencyUtils.formatPriceWithCurrency(
              payout.feesFixedAmountExcludingVat, currencyCode)}
        </td>

        <td
          className="text-center"
        >
          {CurrencyUtils.formatPriceWithCurrency(
              payout.feesVariableAmountExcludingVat, currencyCode)}
        </td>

        <td
          className="text-center"
        >
          {CurrencyUtils.formatPriceWithCurrency(payout.vatAmount,
              currencyCode)}
        </td>

        <td
          className="text-center"
        >
          {CurrencyUtils.formatPriceWithCurrency(payout.getCommissionWithTax(),
              currencyCode)}
        </td>

        <td
          className="text-center"
        >
          {CurrencyUtils.formatPriceWithCurrency(payout.netAmount,
              currencyCode)}
        </td>

        <td
          className="text-center"
        >
          {payout.getFormattedStatus()}
        </td>
      </tr>
    );
  }

}



// WEBPACK FOOTER //
// ./scripts/pages/payment/receipt/components/PayoutsTableViewRow.js